import { actionTypes } from './actionTypes'

export const setRibbonTriggered = () => ({
  type: actionTypes.SET_RIBBON_TRIGGERED,
})
